var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrokeIconRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7126 3.02571L24.7849 1.62184L23.8423 2.66474C20.7137 6.12639 15.2779 6.12569 12.1581 2.6652L11.2149 1.61909L11.2874 3.02571C11.5274 7.6871 7.6871 11.5274 3.02571 11.2874L1.62184 11.2151L2.66474 12.1577C6.12612 15.2861 6.12612 20.7139 2.66474 23.8423L1.62184 24.7849L3.02571 24.7126C7.6871 24.4726 11.5274 28.3129 11.2874 32.9743L11.2151 34.3782L12.1577 33.3353C15.2861 29.8739 20.7139 29.8739 23.8423 33.3353L24.7849 34.3782L24.7126 32.9743C24.4726 28.3129 28.3129 24.4726 32.9743 24.7126L34.3782 24.7849L33.3353 23.8423C29.8739 20.7139 29.8739 15.2861 33.3353 12.1577L34.3782 11.2151L32.9743 11.2874C28.3129 11.5274 24.4726 7.6871 24.7126 3.02571Z",
    fill: "#FC6359",
    stroke: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeIconRock);
export default __webpack_public_path__ + "static/media/stroke-icon-rock.f278600fc7f54fc4742e79159277b31b.svg";
export { ForwardRef as ReactComponent };